export enum COUNTRIES {
  CANADA = 'CA',
  UNITED_STATES = 'US',
}

export enum LOCALES {
  en_US = 'en_US',
  es_US = 'es_US',
  fr_CA = 'fr_CA',
  en_CA = 'en_CA',
} // First element is default locale

export enum FEATURE_FLAGS {
  INVESTMENTS = 'INVESTMENTS',
  RETIREMENT_CALCULATOR = 'RETIREMENT-CALCULATOR',
  POL_CHILDCONVERT = 'POL-CHILDCONVERT',
  DEBT_SOLUTIONS = 'DEBT-SOLUTIONS',
  CUST_VERIFYPHONE = 'CUST-VERIFYPHONE',
  BENEFICIARIES = 'BENEFICIARIES',
  BENEFICIARIES_EDIT = 'BENEFICIARIES_EDIT',
  ENVESTNET_SSO = 'ENVESTNET-SSO',
  ECOMM = 'ECOMM',
  INVESTMENT_CUSTODIAN = 'INVESTMENT-CUSTODIAN',
  VIEW_ACCOUNT_NUMBER = 'VIEW-ACCOUNT-NUMBER',
  ACCOUNT_SETTING_INVESTMENT_PAPERLESS = 'CA-EDELIVERY',
}

export enum ALERT_VIEW_CONTEXT {
  VERIFY_PHONE = 'verify_phone',
}

export enum CHANNELS {
  SMS = 'SMS',
  Email = 'Email',
}

export enum DOCUMENT_OBJECT_TYPES {
  CRC = 'CP6',
}

export enum PREMIUM_DUE_DOCUMENT_OBJECT_TYPES {
  INTB = 'INTB',
  LAPR = 'LAPR',
  UPIG = 'UPIG',
  NPTP = 'NPTP',
}

// commit 27a278c4b2a8e15c7c9b438169993863d78a13e0
export const DOCUMENT_OBJECT_TYPES_PREMIUM_DUE = {
  PREMIUM_DUE: ['INTB', 'LAPR', 'UPIG', 'NPTP'],
};
